import $ from "jquery";
import { TransformParameters } from "../structures/MapDataTypes";
const point72ToNcode = (p) => {
    const NCODE_SIZE_IN_INCH = 8 * 7 / 600;
    const POINT_72DPI_SIZE_IN_INCH = 1 / 72;
    const ratio = NCODE_SIZE_IN_INCH / POINT_72DPI_SIZE_IN_INCH;
    return p / ratio;
};
/**
 *
 * @param {string} xml
 * @param {{filename:string, section:number, owner:number, book:number}} option
 */
export function convertNprojToRegisterItem(xml, options) {
    const $bookXml = $(xml).find("book");
    const title = $bookXml.find("title").text();
    const author = $bookXml.find("author").text();
    const section = parseInt($bookXml.find("section").text());
    const owner = parseInt($bookXml.find("owner").text());
    const book = parseInt($bookXml.find("code").text());
    // const start_page = parseInt($bookXml.find("start_page").text());
    let start_page = parseInt($bookXml.find("start_page").text());
    // const extra_info = $bookXml.find("extra_info").text(); //     <extra_info>pdf_page_count=2</extra_info>, 3.27.603, spring note
    const segment_info = $bookXml.find("segment_info");
    const ncode_start_page_str = segment_info.attr("ncode_start_page");
    if (ncode_start_page_str) {
        const start_page_new = parseInt(ncode_start_page_str);
        start_page = start_page_new;
    }
    const $pdfXml = $(xml).find("pdf");
    const filename = $pdfXml.find("path").text();
    const name = `${author}_${title}_${section}_${owner}_${book}`;
    let Xmin_old = -1;
    let Ymin_old = -1;
    let Xmax_old = -1;
    let Ymax_old = -1;
    let numPages = 0;
    let oldObj = undefined;
    const nprojMargins = [];
    // as {
    //   name: string,
    //   pageInfo: IPageSOBP,
    //   nu: {
    //     Xmin: number,
    //     Ymin: number,
    //     Xmax: number,
    //     Ymax: number,
    //   },
    //   pu: ISize,
    //   Mag: number,
    // }[];
    const pageItems = $(xml).find("page_item");
    // $(xmlData).each(function () {
    pageItems.each((index, item) => {
        // let ccc = $(this);
        const ccc = $(item);
        const x1 = parseFloat(ccc.attr("x1"));
        const x2 = parseFloat(ccc.attr("x2"));
        const y1 = parseFloat(ccc.attr("y1"));
        const y2 = parseFloat(ccc.attr("y2"));
        const crop_margin = ccc.attr("crop_margin");
        const margins = crop_margin.split(",");
        const l = parseFloat(margins[0]);
        const t = parseFloat(margins[1]);
        const r = parseFloat(margins[2]);
        const b = parseFloat(margins[3]);
        const page_no = parseInt(ccc.attr("number"));
        const pu = {
            width: (x2 - r) - (x1 + l),
            height: (y2 - b) - (y1 + t),
        };
        const Xmin = point72ToNcode(x1) + point72ToNcode(l);
        const Ymin = point72ToNcode(y1) + point72ToNcode(t);
        const Xmax_physical = point72ToNcode(x2) - point72ToNcode(r);
        const Ymax_physical = point72ToNcode(y2) - point72ToNcode(b);
        // nl-lib 에서 추가한 homography attribute가 있으면
        const h_attr = ccc.attr("homography");
        let homography = new TransformParameters();
        if (h_attr) {
            const h = h_attr.split(",");
            homography = new TransformParameters({
                type: "homography",
                a: parseFloat(h[0]),
                b: parseFloat(h[1]),
                c: parseFloat(h[2]),
                d: parseFloat(h[3]),
                e: parseFloat(h[4]),
                f: parseFloat(h[5]),
                g: parseFloat(h[6]),
                h: parseFloat(h[7]),
                i: parseFloat(h[8]),
                tx: parseFloat(h[2]),
                ty: parseFloat(h[5])
            });
        }
        // nl-lib 에서 추가한 printed_scale attribute가 있으면
        const printScale_attr = ccc.attr("printed_scale");
        const printedScale = printScale_attr ? parseFloat(printScale_attr) : 1;
        const Xmax = Xmin + point72ToNcode(pu.width) * printedScale;
        const Ymax = Ymin + point72ToNcode(pu.height) * printedScale;
        // 디버깅을 위한 점검, 2021/06/14 kitty
        if (Math.round(Xmax_physical * 100000) !== Math.round(Xmax * 100000)) {
            console.log(`physical_Xmax(${Xmax_physical} is not the same of ${Xmax}`);
        }
        if (Math.round(Ymax_physical * 100000) !== Math.round(Ymax * 100000)) {
            console.log(`physical_Ymax(${Ymax_physical} is not the same of ${Ymax}`);
        }
        // 압축
        if (!(options === null || options === void 0 ? void 0 : options.RLE) || Xmin !== Xmin_old || Xmax !== Xmax_old || Ymin !== Ymin_old || Ymax !== Ymax_old) {
            // console.log(ccc.html());
            if (oldObj) {
                oldObj.numPages = numPages;
            }
            const obj = {
                numPages: undefined,
                name,
                pageInfo: {
                    section,
                    owner,
                    book,
                    page: page_no + start_page,
                },
                nu: {
                    Xmin,
                    Ymin,
                    Xmax,
                    Ymax,
                },
                pu: pu,
                whole: {
                    x1, y1, x2, y2,
                },
                crop_margin: {
                    left: l,
                    top: t,
                    right: r,
                    bottom: b,
                },
                Mag: 1,
                homography
            };
            // console.log(obj);
            nprojMargins.push(obj);
            oldObj = obj;
            numPages = 0;
            Xmin_old = Xmin;
            Xmax_old = Xmax;
            Ymin_old = Ymin;
            Ymax_old = Ymax;
            // console.log(`${section}.${owner}.${book} ==> ${filename}/${page_no} ==> ${crop_margin}`);
        }
        numPages++;
        // console.log(index, numPages);
    });
    if (oldObj) {
        oldObj.numPages = numPages;
    }
    // "/background_pdf/3_1012_1191/3_1012_1191_Math_TokTok_3-1.pdf",
    const pdf_url_from_paperhub = (options === null || options === void 0 ? void 0 : options.getPdfUrlFn) ? options.getPdfUrlFn(filename, options.nproj_url) : undefined;
    const ret = {
        section,
        owner,
        book,
        nproj_url: options === null || options === void 0 ? void 0 : options.nproj_url,
        pdf_url_from_paperhub,
        pdf_url_for_mapper: pdf_url_from_paperhub,
        background_image_url_rule: options === null || options === void 0 ? void 0 : options.background_image_url_rule,
        name: title,
        filename,
        fingerprint: options === null || options === void 0 ? void 0 : options.pdf_fingerprint,
        startPage: start_page,
        numPages: pageItems.length,
        nprojMargins, // INprojMarginType[],
    };
    return ret;
}
//# sourceMappingURL=nprojToRegisterItem.js.map